/* Texty „Můj tým“ a pozvánky do týmu — pět jazyků v JEDNOM souboru.
 * ============================================================================
 * Proč tady a ne ve velkých slovnících (data/translations/*.js): ty dnes mění
 * paralelní týmy a sdílené soubory se smí upravovat jen malou přesnou náhradou.
 * Vložený slovník drží všechny texty Nastavení → Můj tým, /pozvanka/:token,
 * formuláře pozvání a tlačítek na obrazovce Tým pohromadě.
 *
 * Pravidla:
 *  · chybějící jazyk / klíč → čeština (nikdy prázdno, nikdy holý klíč),
 *  · {jmeno}, {email}, {datum}, {n}… se dosazují funkcí `textTymu`,
 *  · rod neutrální („Už nejsi v týmu.“, „Přihlášení: {email}“),
 *  · jméno vždy v 1. pádě („Vede ho {jmeno}.“, „z týmu ({jmeno})“) — šablona
 *    jméno neskloní a „v týmu Alena Nová“ je chyba,
 *  · souhlasové věty („co manažer uvidí“) sem NEPATŘÍ — zůstávají ve slovníku
 *    vykonTymu.informace.* (verze INFORMACE_VERZE je s nimi svázaná),
 *  · čistý JS bez Reactu (hook je v useTextyTymu.js), ať ho smí i tymRoster.
 */
export const TEXTY_TYMU = {
  cs: {
    nadpis: "Můj tým",
    veTymu: "Ve tvém týmu: {n}",
    otevritTym: "Otevřít Tým",
    // Pozvat do týmu
    pozvatNadpis: "Pozvat do týmu",
    emailPopisek: "E-mail kolegy",
    emailPlaceholder: "jmeno@firma.cz",
    pozvat: "Pozvat",
    neplatnyEmail: "Zadej platný e-mail.",
    uzVTymu: "{email} už je ve tvém týmu.",
    vytvorena: "Pozvánka je připravená. Pošli kolegovi odkaz.",
    uzCeka: "Pozvánka už čeká, pošli odkaz znovu.",
    odkazPro: "Odkaz pro {email}",
    sdilet: "Sdílet",
    whatsapp: "WhatsApp",
    sms: "SMS",
    kopirovat: "Kopírovat odkaz",
    poslatOdkaz: "Poslat odkaz",
    zkopirovano: "Odkaz zkopírován.",
    kopirovaniSelhalo: "Zkopírovat se nepovedlo — označ odkaz ručně.",
    zprava1: "Ahoj, zvu tě do svého týmu v B-PLAN University.",
    zprava2: "Pozvánku přijmeš tady: {odkaz}",
    zprava3: "Platí do {datum}.",
    odeslane: "Odeslané pozvánky",
    zbyvaJeden: "zbývá {n} den",
    zbyvaMalo: "zbývá {n} dny",
    zbyvaMnoho: "zbývá {n} dní",
    stavVyprsela: "Vypršela",
    stavOdmitnuta: "Odmítnuta",
    stavKonflikt: "Má jiného manažera",
    stavProbiha: "Přijímá se",
    zrusit: "Zrušit",
    pozvatZnovu: "Pozvat znovu",
    zrusena: "Pozvánka zrušena.",
    prijataVeta: "Pozvánka přijata. Tým najdeš v menu.",
    seznamChyba: "Seznam pozvánek se nepodařilo načíst.",
    // Můj manažer
    nacitam: "Načítám…",
    chybaStavu: "Stav se nepodařilo načíst",
    znovu: "Zkusit znovu",
    mujManazer: "Tvůj manažer",
    od: "od {datum}",
    datumNeznamy: "datum neznáme",
    zadny: "Zatím nemáš manažera.",
    zveTe: "{jmeno} tě zve do týmu",
    platiDo: "Platí do {datum}",
    platnostNeznama: "Platnost neznáme.",
    prijmout: "Přijmout",
    odmitnout: "Odmítnout",
    opravduOdmitnout: "Opravdu odmítnout?",
    anoOdmitnout: "Ano, odmítnout",
    zpet: "Zpět",
    prijato: "Jsi v týmu.",
    odmitnuto: "Pozvánka odmítnuta.",
    kolize: "Nejdřív odejdi ze současného týmu ({jmeno}).",
    odejit: "Odejít z týmu",
    odejitJmeno: "Odejít z týmu ({jmeno})",
    odejitPotvrzeni: "Opravdu odejít? {jmeno} přestane vidět tvoje klienty a výkon.",
    anoOdejit: "Ano, odejít",
    odesel: "Už nejsi v týmu.",
    staryServer: "Server tohle zatím neumí — je potřeba nasadit novou verzi backendu.",
    tvujManazerFallback: "tvůj manažer",
    // Veřejná stránka /pozvanka/:token
    kicker: "Pozvánka do týmu",
    proEmail: "Pro {email} · platí do {datum}",
    proEmailBezData: "Pro {email}",
    chybaNacteni: "Pozvánku se nepodařilo načíst.",
    prilisCasto: "Moc pokusů za sebou. Zkus to za pár minut znovu.",
    nenalezena: "Pozvánka neexistuje nebo už neplatí. Požádej toho, kdo tě zve, o novou.",
    starsiServer: "Přihlas se a pozvánku přijmi v Nastavení → Můj tým.",
    clen: "Už jsi v týmu. Vede ho {jmeno}.",
    neplatnaZvouci: "Tahle pozvánka už neplatí. Pozvi kolegu znovu v Nastavení → Můj tým.",
    prihlasit: "Přihlásit se",
    sso: "Přihlásit přes BEplan SSO",
    zalozit: "Založit účet",
    nemasUcet: "Nemáš účet? Požádej toho, kdo tě zve.",
    hotovo: "Jsi v týmu. Vede ho {jmeno}.",
    doAplikace: "Do aplikace",
    jinyUcet: "Pozvánka je pro {pro}. Přihlášení: {email}.",
    prihlasitJinym: "Přihlásit jiným účtem",
    zvouci: "Tohle je tvoje pozvánka. Pošli odkaz kolegovi.",
    nekdo: "Kolega",
    // Přihlášení z pozvánky
    zPozvanky: "Zakládáš účet z pozvánky. Použij e-mail {email}.",
    zPozvankyBezEmailu: "Zakládáš účet z pozvánky. Použij e-mail, na který přišla.",
    hesloMin8: "Heslo musí mít aspoň 8 znaků.",
    kodOdeslan: "Poslali jsme ti kód na {email}. Zadej ho a účet je hotový.",
    kodPopisek: "Kód z e-mailu",
    dokoncit: "Dokončit",
    poslatKodZnovu: "Poslat kód znovu",
    kodZnovuPoslan: "Kód jsme poslali znovu.",
    // Obrazovka Tým
    tymH1: "Tým",
    tymPrazdny: "V týmu zatím nikdo není.",
    odebrat: "Odebrat z týmu",
    odebratPotvrzeni: "Odebrat z týmu: {jmeno}? Přestaneš vidět klienty a výkon tohoto člověka.",
    anoOdebrat: "Ano, odebrat",
    odebrano: "{jmeno} už není ve tvém týmu.",
    overuji: "Ověřuji tým…",
    tymNacitam: "Načítám tým…",
    tymChyba: "Tým se nepodařilo načíst",
    tymTimeout: "Server neodpověděl včas (12 s). Zkus to prosím znovu.",
    tymChybaKod: "Chyba: {kod}. Zkus to prosím znovu.",
    tymDiagnostika: "Diagnostický kód: {kod}",
  },
  sk: {
    nadpis: "Môj tím",
    veTymu: "V tvojom tíme: {n}",
    otevritTym: "Otvoriť Tím",
    pozvatNadpis: "Pozvať do tímu",
    emailPopisek: "E-mail kolegu",
    emailPlaceholder: "meno@firma.sk",
    pozvat: "Pozvať",
    neplatnyEmail: "Zadaj platný e-mail.",
    uzVTymu: "{email} už je v tvojom tíme.",
    vytvorena: "Pozvánka je pripravená. Pošli kolegovi odkaz.",
    uzCeka: "Pozvánka už čaká, pošli odkaz znova.",
    odkazPro: "Odkaz pre {email}",
    sdilet: "Zdieľať",
    whatsapp: "WhatsApp",
    sms: "SMS",
    kopirovat: "Kopírovať odkaz",
    poslatOdkaz: "Poslať odkaz",
    zkopirovano: "Odkaz skopírovaný.",
    kopirovaniSelhalo: "Skopírovať sa nepodarilo — označ odkaz ručne.",
    zprava1: "Ahoj, pozývam ťa do svojho tímu v B-PLAN University.",
    zprava2: "Pozvánku prijmeš tu: {odkaz}",
    zprava3: "Platí do {datum}.",
    odeslane: "Odoslané pozvánky",
    zbyvaJeden: "zostáva {n} deň",
    zbyvaMalo: "zostávajú {n} dni",
    zbyvaMnoho: "zostáva {n} dní",
    stavVyprsela: "Vypršala",
    stavOdmitnuta: "Odmietnutá",
    stavKonflikt: "Má iného manažéra",
    stavProbiha: "Prijíma sa",
    zrusit: "Zrušiť",
    pozvatZnovu: "Pozvať znova",
    zrusena: "Pozvánka zrušená.",
    prijataVeta: "Pozvánka prijatá. Tím nájdeš v menu.",
    seznamChyba: "Zoznam pozvánok sa nepodarilo načítať.",
    nacitam: "Načítavam…",
    chybaStavu: "Stav sa nepodarilo načítať",
    znovu: "Skúsiť znova",
    mujManazer: "Tvoj manažér",
    od: "od {datum}",
    datumNeznamy: "dátum nepoznáme",
    zadny: "Zatiaľ nemáš manažéra.",
    zveTe: "{jmeno} ťa pozýva do tímu",
    platiDo: "Platí do {datum}",
    platnostNeznama: "Platnosť nepoznáme.",
    prijmout: "Prijať",
    odmitnout: "Odmietnuť",
    opravduOdmitnout: "Naozaj odmietnuť?",
    anoOdmitnout: "Áno, odmietnuť",
    zpet: "Späť",
    prijato: "Si v tíme.",
    odmitnuto: "Pozvánka odmietnutá.",
    kolize: "Najprv odíď zo súčasného tímu ({jmeno}).",
    odejit: "Odísť z tímu",
    odejitJmeno: "Odísť z tímu ({jmeno})",
    odejitPotvrzeni: "Naozaj odísť? {jmeno} prestane vidieť tvojich klientov a výkon.",
    anoOdejit: "Áno, odísť",
    odesel: "Už nie si v tíme.",
    staryServer: "Server to zatiaľ nevie — je potrebné nasadiť novú verziu backendu.",
    tvujManazerFallback: "tvoj manažér",
    kicker: "Pozvánka do tímu",
    proEmail: "Pre {email} · platí do {datum}",
    proEmailBezData: "Pre {email}",
    chybaNacteni: "Pozvánku sa nepodarilo načítať.",
    prilisCasto: "Príliš veľa pokusov za sebou. Skús to o pár minút znova.",
    nenalezena: "Pozvánka neexistuje alebo už neplatí. Požiadaj toho, kto ťa pozýva, o novú.",
    starsiServer: "Prihlás sa a pozvánku prijmi v Nastaveniach → Môj tím.",
    clen: "Už si v tíme. Vedie ho {jmeno}.",
    neplatnaZvouci: "Táto pozvánka už neplatí. Pozvi kolegu znova v Nastaveniach → Môj tím.",
    prihlasit: "Prihlásiť sa",
    sso: "Prihlásiť cez BEplan SSO",
    zalozit: "Založiť účet",
    nemasUcet: "Nemáš účet? Požiadaj toho, kto ťa pozýva.",
    hotovo: "Si v tíme. Vedie ho {jmeno}.",
    doAplikace: "Do aplikácie",
    jinyUcet: "Pozvánka je pre {pro}. Prihlásenie: {email}.",
    prihlasitJinym: "Prihlásiť iným účtom",
    zvouci: "Toto je tvoja pozvánka. Pošli odkaz kolegovi.",
    nekdo: "Kolega",
    zPozvanky: "Zakladáš účet z pozvánky. Použi e-mail {email}.",
    zPozvankyBezEmailu: "Zakladáš účet z pozvánky. Použi e-mail, na ktorý prišla.",
    hesloMin8: "Heslo musí mať aspoň 8 znakov.",
    kodOdeslan: "Poslali sme ti kód na {email}. Zadaj ho a účet je hotový.",
    kodPopisek: "Kód z e-mailu",
    dokoncit: "Dokončiť",
    poslatKodZnovu: "Poslať kód znova",
    kodZnovuPoslan: "Kód sme poslali znova.",
    tymH1: "Tím",
    tymPrazdny: "V tíme zatiaľ nikto nie je.",
    odebrat: "Odobrať z tímu",
    odebratPotvrzeni: "Odobrať z tímu: {jmeno}? Prestaneš vidieť klientov a výkon tohto človeka.",
    anoOdebrat: "Áno, odobrať",
    odebrano: "{jmeno} už nie je v tvojom tíme.",
    overuji: "Overujem tím…",
    tymNacitam: "Načítavam tím…",
    tymChyba: "Tím sa nepodarilo načítať",
    tymTimeout: "Server neodpovedal včas (12 s). Skús to prosím znova.",
    tymChybaKod: "Chyba: {kod}. Skús to prosím znova.",
    tymDiagnostika: "Diagnostický kód: {kod}",
  },
  en: {
    nadpis: "My team",
    veTymu: "In your team: {n}",
    otevritTym: "Open Team",
    pozvatNadpis: "Invite to the team",
    emailPopisek: "Colleague's e-mail",
    emailPlaceholder: "name@company.com",
    pozvat: "Invite",
    neplatnyEmail: "Enter a valid e-mail.",
    uzVTymu: "{email} is already in your team.",
    vytvorena: "The invitation is ready. Send your colleague the link.",
    uzCeka: "The invitation is already waiting, send the link again.",
    odkazPro: "Link for {email}",
    sdilet: "Share",
    whatsapp: "WhatsApp",
    sms: "SMS",
    kopirovat: "Copy link",
    poslatOdkaz: "Send link",
    zkopirovano: "Link copied.",
    kopirovaniSelhalo: "Copying failed — select the link by hand.",
    zprava1: "Hi, I am inviting you to my team in B-PLAN University.",
    zprava2: "Accept the invitation here: {odkaz}",
    zprava3: "Valid until {datum}.",
    odeslane: "Sent invitations",
    zbyvaJeden: "{n} day left",
    zbyvaMalo: "{n} days left",
    zbyvaMnoho: "{n} days left",
    stavVyprsela: "Expired",
    stavOdmitnuta: "Declined",
    stavKonflikt: "Has another manager",
    stavProbiha: "Being accepted",
    zrusit: "Cancel",
    pozvatZnovu: "Invite again",
    zrusena: "Invitation cancelled.",
    prijataVeta: "Invitation accepted. You will find Team in the menu.",
    seznamChyba: "The list of invitations could not be loaded.",
    nacitam: "Loading…",
    chybaStavu: "The status could not be loaded",
    znovu: "Try again",
    mujManazer: "Your manager",
    od: "since {datum}",
    datumNeznamy: "date unknown",
    zadny: "You have no manager yet.",
    zveTe: "{jmeno} invites you to the team",
    platiDo: "Valid until {datum}",
    platnostNeznama: "Validity unknown.",
    prijmout: "Accept",
    odmitnout: "Decline",
    opravduOdmitnout: "Really decline?",
    anoOdmitnout: "Yes, decline",
    zpet: "Back",
    prijato: "You are in the team.",
    odmitnuto: "Invitation declined.",
    kolize: "First leave the team of {jmeno}.",
    odejit: "Leave the team",
    odejitJmeno: "Leave the team of {jmeno}",
    odejitPotvrzeni: "Really leave? {jmeno} will stop seeing your clients and performance.",
    anoOdejit: "Yes, leave",
    odesel: "You are no longer in the team.",
    staryServer: "The server cannot do this yet — a new backend version needs to be deployed.",
    tvujManazerFallback: "your manager",
    kicker: "Team invitation",
    proEmail: "For {email} · valid until {datum}",
    proEmailBezData: "For {email}",
    chybaNacteni: "The invitation could not be loaded.",
    prilisCasto: "Too many attempts in a row. Try again in a few minutes.",
    nenalezena: "The invitation does not exist or is no longer valid. Ask the person inviting you for a new one.",
    starsiServer: "Sign in and accept the invitation in Settings → My team.",
    clen: "You are already in the team of {jmeno}.",
    neplatnaZvouci: "This invitation is no longer valid. Invite your colleague again in Settings → My team.",
    prihlasit: "Sign in",
    sso: "Sign in with BEplan SSO",
    zalozit: "Create an account",
    nemasUcet: "No account? Ask the person inviting you.",
    hotovo: "You are in the team of {jmeno}.",
    doAplikace: "Go to the app",
    jinyUcet: "The invitation is for {pro}. Signed in: {email}.",
    prihlasitJinym: "Sign in with another account",
    zvouci: "This is your invitation. Send the link to your colleague.",
    nekdo: "A colleague",
    zPozvanky: "You are creating an account from an invitation. Use the e-mail {email}.",
    zPozvankyBezEmailu: "You are creating an account from an invitation. Use the e-mail it was sent to.",
    hesloMin8: "The password must have at least 8 characters.",
    kodOdeslan: "We sent a code to {email}. Enter it and your account is ready.",
    kodPopisek: "Code from the e-mail",
    dokoncit: "Finish",
    poslatKodZnovu: "Send the code again",
    kodZnovuPoslan: "We sent the code again.",
    tymH1: "Team",
    tymPrazdny: "Nobody is in the team yet.",
    odebrat: "Remove from team",
    odebratPotvrzeni: "Remove {jmeno}? You will stop seeing their clients and performance.",
    anoOdebrat: "Yes, remove",
    odebrano: "{jmeno} is no longer in your team.",
    overuji: "Checking your team…",
    tymNacitam: "Loading the team…",
    tymChyba: "The team could not be loaded",
    tymTimeout: "The server did not answer in time (12 s). Please try again.",
    tymChybaKod: "Error: {kod}. Please try again.",
    tymDiagnostika: "Diagnostic code: {kod}",
  },
  uk: {
    nadpis: "Моя команда",
    veTymu: "У твоїй команді: {n}",
    otevritTym: "Відкрити Команду",
    pozvatNadpis: "Запросити до команди",
    emailPopisek: "E-mail колеги",
    emailPlaceholder: "imya@firma.cz",
    pozvat: "Запросити",
    neplatnyEmail: "Введи правильний e-mail.",
    uzVTymu: "{email} уже у твоїй команді.",
    vytvorena: "Запрошення готове. Надішли колезі посилання.",
    uzCeka: "Запрошення вже чекає, надішли посилання ще раз.",
    odkazPro: "Посилання для {email}",
    sdilet: "Поділитися",
    whatsapp: "WhatsApp",
    sms: "SMS",
    kopirovat: "Копіювати посилання",
    poslatOdkaz: "Надіслати посилання",
    zkopirovano: "Посилання скопійовано.",
    kopirovaniSelhalo: "Скопіювати не вдалося — виділи посилання вручну.",
    zprava1: "Привіт, запрошую тебе до своєї команди в B-PLAN University.",
    zprava2: "Прийняти запрошення можна тут: {odkaz}",
    zprava3: "Дійсне до {datum}.",
    odeslane: "Надіслані запрошення",
    zbyvaJeden: "залишився {n} день",
    zbyvaMalo: "залишилося {n} дні",
    zbyvaMnoho: "залишилося {n} днів",
    stavVyprsela: "Термін минув",
    stavOdmitnuta: "Відхилено",
    stavKonflikt: "Має іншого менеджера",
    stavProbiha: "Приймається",
    zrusit: "Скасувати",
    pozvatZnovu: "Запросити знову",
    zrusena: "Запрошення скасовано.",
    prijataVeta: "Запрошення прийнято. Команду знайдеш у меню.",
    seznamChyba: "Не вдалося завантажити список запрошень.",
    nacitam: "Завантаження…",
    chybaStavu: "Не вдалося завантажити стан",
    znovu: "Спробувати знову",
    mujManazer: "Твій менеджер",
    od: "з {datum}",
    datumNeznamy: "дата невідома",
    zadny: "Поки що в тебе немає менеджера.",
    zveTe: "{jmeno} запрошує тебе до команди",
    platiDo: "Дійсне до {datum}",
    platnostNeznama: "Термін дії невідомий.",
    prijmout: "Прийняти",
    odmitnout: "Відхилити",
    opravduOdmitnout: "Справді відхилити?",
    anoOdmitnout: "Так, відхилити",
    zpet: "Назад",
    prijato: "Ти в команді.",
    odmitnuto: "Запрошення відхилено.",
    kolize: "Спочатку вийди з поточної команди ({jmeno}).",
    odejit: "Вийти з команди",
    odejitJmeno: "Вийти з команди ({jmeno})",
    odejitPotvrzeni: "Справді вийти? {jmeno} більше не бачитиме твоїх клієнтів і результати.",
    anoOdejit: "Так, вийти",
    odesel: "Ти більше не в команді.",
    staryServer: "Сервер поки цього не вміє — потрібно розгорнути нову версію бекенду.",
    tvujManazerFallback: "твій менеджер",
    kicker: "Запрошення до команди",
    proEmail: "Для {email} · дійсне до {datum}",
    proEmailBezData: "Для {email}",
    chybaNacteni: "Не вдалося завантажити запрошення.",
    prilisCasto: "Забагато спроб поспіль. Спробуй ще раз за кілька хвилин.",
    nenalezena: "Запрошення не існує або вже недійсне. Попроси того, хто запрошує, про нове.",
    starsiServer: "Увійди та прийми запрошення в Налаштуваннях → Моя команда.",
    clen: "Ти вже в команді. Її веде {jmeno}.",
    neplatnaZvouci: "Це запрошення вже недійсне. Запроси колегу знову в Налаштуваннях → Моя команда.",
    prihlasit: "Увійти",
    sso: "Увійти через BEplan SSO",
    zalozit: "Створити обліковий запис",
    nemasUcet: "Немає облікового запису? Попроси того, хто запрошує.",
    hotovo: "Ти в команді. Її веде {jmeno}.",
    doAplikace: "До застосунку",
    jinyUcet: "Запрошення для {pro}. Вхід: {email}.",
    prihlasitJinym: "Увійти іншим обліковим записом",
    zvouci: "Це твоє запрошення. Надішли посилання колезі.",
    nekdo: "Колега",
    zPozvanky: "Ти створюєш обліковий запис із запрошення. Використай e-mail {email}.",
    zPozvankyBezEmailu: "Ти створюєш обліковий запис із запрошення. Використай e-mail, на який воно прийшло.",
    hesloMin8: "Пароль має містити щонайменше 8 символів.",
    kodOdeslan: "Ми надіслали код на {email}. Введи його — і обліковий запис готовий.",
    kodPopisek: "Код з e-mail",
    dokoncit: "Завершити",
    poslatKodZnovu: "Надіслати код ще раз",
    kodZnovuPoslan: "Ми надіслали код ще раз.",
    tymH1: "Команда",
    tymPrazdny: "У команді поки нікого немає.",
    odebrat: "Вилучити з команди",
    odebratPotvrzeni: "Вилучити з команди: {jmeno}? Ти більше не бачитимеш клієнтів і результатів цієї людини.",
    anoOdebrat: "Так, вилучити",
    odebrano: "{jmeno} більше не у твоїй команді.",
    overuji: "Перевіряю команду…",
    tymNacitam: "Завантажую команду…",
    tymChyba: "Не вдалося завантажити команду",
    tymTimeout: "Сервер не відповів вчасно (12 с). Спробуй ще раз.",
    tymChybaKod: "Помилка: {kod}. Спробуй ще раз.",
    tymDiagnostika: "Діагностичний код: {kod}",
  },
  vi: {
    nadpis: "Nhóm của tôi",
    veTymu: "Trong nhóm của bạn: {n}",
    otevritTym: "Mở Nhóm",
    pozvatNadpis: "Mời vào nhóm",
    emailPopisek: "E-mail của đồng nghiệp",
    emailPlaceholder: "ten@congty.cz",
    pozvat: "Mời",
    neplatnyEmail: "Hãy nhập e-mail hợp lệ.",
    uzVTymu: "{email} đã ở trong nhóm của bạn.",
    vytvorena: "Lời mời đã sẵn sàng. Hãy gửi đường dẫn cho đồng nghiệp.",
    uzCeka: "Lời mời đang chờ, hãy gửi lại đường dẫn.",
    odkazPro: "Đường dẫn cho {email}",
    sdilet: "Chia sẻ",
    whatsapp: "WhatsApp",
    sms: "SMS",
    kopirovat: "Sao chép đường dẫn",
    poslatOdkaz: "Gửi đường dẫn",
    zkopirovano: "Đã sao chép đường dẫn.",
    kopirovaniSelhalo: "Không sao chép được — hãy tự bôi chọn đường dẫn.",
    zprava1: "Chào bạn, mình mời bạn vào nhóm của mình trên B-PLAN University.",
    zprava2: "Chấp nhận lời mời tại đây: {odkaz}",
    zprava3: "Có hiệu lực đến {datum}.",
    odeslane: "Lời mời đã gửi",
    zbyvaJeden: "còn {n} ngày",
    zbyvaMalo: "còn {n} ngày",
    zbyvaMnoho: "còn {n} ngày",
    stavVyprsela: "Đã hết hạn",
    stavOdmitnuta: "Đã từ chối",
    stavKonflikt: "Đã có quản lý khác",
    stavProbiha: "Đang chấp nhận",
    zrusit: "Hủy",
    pozvatZnovu: "Mời lại",
    zrusena: "Đã hủy lời mời.",
    prijataVeta: "Lời mời đã được chấp nhận. Mục Nhóm có trong menu.",
    seznamChyba: "Không tải được danh sách lời mời.",
    nacitam: "Đang tải…",
    chybaStavu: "Không tải được trạng thái",
    znovu: "Thử lại",
    mujManazer: "Quản lý của bạn",
    od: "từ {datum}",
    datumNeznamy: "chưa rõ ngày",
    zadny: "Bạn chưa có quản lý.",
    zveTe: "{jmeno} mời bạn vào nhóm",
    platiDo: "Có hiệu lực đến {datum}",
    platnostNeznama: "Chưa rõ thời hạn.",
    prijmout: "Chấp nhận",
    odmitnout: "Từ chối",
    opravduOdmitnout: "Bạn chắc chắn muốn từ chối?",
    anoOdmitnout: "Có, từ chối",
    zpet: "Quay lại",
    prijato: "Bạn đã ở trong nhóm.",
    odmitnuto: "Đã từ chối lời mời.",
    kolize: "Trước tiên hãy rời nhóm của {jmeno}.",
    odejit: "Rời nhóm",
    odejitJmeno: "Rời nhóm của {jmeno}",
    odejitPotvrzeni: "Bạn chắc chắn muốn rời? {jmeno} sẽ không còn thấy khách hàng và kết quả của bạn.",
    anoOdejit: "Có, rời nhóm",
    odesel: "Bạn không còn ở trong nhóm.",
    staryServer: "Máy chủ chưa hỗ trợ việc này — cần triển khai phiên bản backend mới.",
    tvujManazerFallback: "quản lý của bạn",
    kicker: "Lời mời vào nhóm",
    proEmail: "Dành cho {email} · hiệu lực đến {datum}",
    proEmailBezData: "Dành cho {email}",
    chybaNacteni: "Không tải được lời mời.",
    prilisCasto: "Bạn đã thử quá nhiều lần. Hãy thử lại sau vài phút.",
    nenalezena: "Lời mời không tồn tại hoặc đã hết hiệu lực. Hãy xin người mời gửi lời mời mới.",
    starsiServer: "Hãy đăng nhập và chấp nhận lời mời trong Cài đặt → Nhóm của tôi.",
    clen: "Bạn đã ở trong nhóm của {jmeno}.",
    neplatnaZvouci: "Lời mời này đã hết hiệu lực. Hãy mời lại đồng nghiệp trong Cài đặt → Nhóm của tôi.",
    prihlasit: "Đăng nhập",
    sso: "Đăng nhập bằng BEplan SSO",
    zalozit: "Tạo tài khoản",
    nemasUcet: "Chưa có tài khoản? Hãy hỏi người mời bạn.",
    hotovo: "Bạn đã ở trong nhóm của {jmeno}.",
    doAplikace: "Vào ứng dụng",
    jinyUcet: "Lời mời dành cho {pro}. Đang đăng nhập: {email}.",
    prihlasitJinym: "Đăng nhập bằng tài khoản khác",
    zvouci: "Đây là lời mời của bạn. Hãy gửi đường dẫn cho đồng nghiệp.",
    nekdo: "Đồng nghiệp",
    zPozvanky: "Bạn đang tạo tài khoản từ lời mời. Hãy dùng e-mail {email}.",
    zPozvankyBezEmailu: "Bạn đang tạo tài khoản từ lời mời. Hãy dùng e-mail đã nhận lời mời.",
    hesloMin8: "Mật khẩu phải có ít nhất 8 ký tự.",
    kodOdeslan: "Chúng tôi đã gửi mã đến {email}. Hãy nhập mã để hoàn tất tài khoản.",
    kodPopisek: "Mã trong e-mail",
    dokoncit: "Hoàn tất",
    poslatKodZnovu: "Gửi lại mã",
    kodZnovuPoslan: "Chúng tôi đã gửi lại mã.",
    tymH1: "Nhóm",
    tymPrazdny: "Chưa có ai trong nhóm.",
    odebrat: "Xóa khỏi nhóm",
    odebratPotvrzeni: "Xóa {jmeno} khỏi nhóm? Bạn sẽ không còn thấy khách hàng và kết quả của họ.",
    anoOdebrat: "Có, xóa",
    odebrano: "{jmeno} không còn ở trong nhóm của bạn.",
    overuji: "Đang kiểm tra nhóm…",
    tymNacitam: "Đang tải nhóm…",
    tymChyba: "Không tải được nhóm",
    tymTimeout: "Máy chủ không phản hồi kịp (12 giây). Hãy thử lại.",
    tymChybaKod: "Lỗi: {kod}. Hãy thử lại.",
    tymDiagnostika: "Mã chẩn đoán: {kod}",
  },
};

const LOCALE = { cs: "cs-CZ", sk: "sk-SK", en: "en-GB", uk: "uk-UA", vi: "vi-VN" };

/** Locale pro datum podle jazyka UI (měna s tím nesouvisí). */
export function localeTymu(lang) {
  return LOCALE[lang] || LOCALE.cs;
}

/** Text v jazyce `lang`; chybějící jazyk / klíč → čeština, nikdy holý klíč. */
export function textTymu(lang, klic, parametry) {
  const slovnik = TEXTY_TYMU[lang] || TEXTY_TYMU.cs;
  let s = slovnik[klic];
  if (typeof s !== "string" || !s) s = TEXTY_TYMU.cs[klic];
  if (typeof s !== "string") return "";
  if (parametry) {
    s = s.replace(/\{(\w+)\}/g, (cele, k) => (parametry[k] === undefined || parametry[k] === null ? cele : String(parametry[k])));
  }
  return s;
}

/** „zbývá 1 den / 3 dny / 5 dní“ — čeština a slovenština skloňují, ukrajinština taky. */
export function zbyvaText(lang, n) {
  const abs = Math.abs(n);
  const deset = abs % 10;
  const sto = abs % 100;
  let klic = "zbyvaMnoho";
  if (lang === "uk") {
    if (deset === 1 && sto !== 11) klic = "zbyvaJeden";
    else if (deset >= 2 && deset <= 4 && (sto < 12 || sto > 14)) klic = "zbyvaMalo";
  } else if (abs === 1) {
    klic = "zbyvaJeden";
  } else if (abs >= 2 && abs <= 4) {
    klic = "zbyvaMalo";
  }
  return textTymu(lang, klic, { n });
}
